import { defineMessages } from 'react-intl';

const messages = defineMessages({
  createTotesHeader: {
    description: 'Header for the create totes drawer',
    defaultMessage: 'Create Totes',
    id: 'ciX83Y',
  },
  createTotesDescription: {
    description: 'Description for the create totes drawer',
    defaultMessage: 'Generate totes in bulk by entering the quantity, base name, and starting number. You can also add them one at a time.',
    id: 'RPQzur',
  },
  generateTotesButton: {
    description: 'Button text to generate totes',
    defaultMessage: 'Generate',
    id: 'EPxFPM',
  },
  quantityInputLabel: {
    description: 'Label for the quantity input field',
    defaultMessage: 'Quantity',
    id: '7Vs/XP',
  },
  baseNameInputLabel: {
    description: 'Label for the base name input field',
    defaultMessage: 'Base name',
    id: 'itLIW3',
  },
  startNumberInputLabel: {
    description: 'Label for the start number input field',
    defaultMessage: 'Start numbering from:',
    id: 'R7VY3k',
  },
  baseNameInputPlaceholder: {
    description: 'Placeholder for the base name input field',
    defaultMessage: 'Eg: Color, size, or ID',
    id: 'LXU2Ah',
  },
  addSingleToteButton: {
    description: 'Button text to add a single empty tote',
    defaultMessage: 'Add one at a time',
    id: 'MU35mh',
  },
  errorAddingTotesBanner: {
    description: 'Error message in banner when adding totes fails',
    defaultMessage: 'Unable to create totes. Please fix remaining ones below and try again. Tote name and barcode must be unique.',
    id: 'yEK5pQ',
  },
});

export default messages;
